import { render, staticRenderFns } from "./AdministracionTools.vue?vue&type=template&id=ed5c6360&"
import script from "./AdministracionTools.vue?vue&type=script&lang=js&"
export * from "./AdministracionTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports